export const GET_REDIRECT_CALL_BLOCK_REQUEST = "GET_REDIRECT_CALL_BLOCK_REQUEST";
export const GET_REDIRECT_CALL_BLOCK_SUCCESS = "GET_REDIRECT_CALL_BLOCK_SUCCESS";
export const GET_REDIRECT_CALL_BLOCK_FAIL = "GET_REDIRECT_CALL_BLOCK_FAIL";

export const CREATE_REDIRECT_CALL_BLOCK_REQUEST = "CREATE_REDIRECT_CALL_BLOCK_REQUEST";
export const CREATE_REDIRECT_CALL_BLOCK_SUCCESS = "CREATE_REDIRECT_CALL_BLOCK_SUCCESS";
export const CREATE_REDIRECT_CALL_BLOCK_FAIL = "CREATE_REDIRECT_CALL_BLOCK_FAIL";

export const UPDATE_REDIRECT_CALL_BLOCK_REQUEST = "UPDATE_REDIRECT_CALL_BLOCK_REQUEST";
export const UPDATE_REDIRECT_CALL_BLOCK_SUCCESS = "UPDATE_REDIRECT_CALL_BLOCK_SUCCESS";
export const UPDATE_REDIRECT_CALL_BLOCK_FAIL = "UPDATE_REDIRECT_CALL_BLOCK_FAIL";

export const DELETE_REDIRECT_CALL_BLOCK_REQUEST = "DELETE_REDIRECT_CALL_BLOCK_REQUEST";
export const DELETE_REDIRECT_CALL_BLOCK_SUCCESS = "DELETE_REDIRECT_CALL_BLOCK_SUCCESS";
export const DELETE_REDIRECT_CALL_BLOCK_FAIL = "DELETE_REDIRECT_CALL_BLOCK_FAIL";

export const UPDATE_USER_CALL_BLOCK_STATUS_REQUEST = "UPDATE_USER_CALL_BLOCK_STATUS_REQUEST";
export const UPDATE_USER_CALL_BLOCK_STATUS_SUCCESS = "UPDATE_USER_CALL_BLOCK_STATUS_SUCCESS";
export const UPDATE_USER_CALL_BLOCK_STATUS_RESET = "UPDATE_USER_CALL_BLOCK_STATUS_RESET";
export const UPDATE_USER_CALL_BLOCK_STATUS_FAIL = "UPDATE_USER_CALL_BLOCK_STATUS_FAIL";